export default function initHeroCanvas() {
  const canvas = document.getElementById("heroCanvas");
  if (!canvas) return;

  const ctx = canvas.getContext("2d");
  if (!ctx) return;

  const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (prefersReducedMotion) return;

  let width, height;
  let particles = [];
  let animId;
  let time = 0;

  function resize() {
    const hero = canvas.parentElement;
    width = canvas.width = hero.offsetWidth;
    height = canvas.height = hero.offsetHeight;
  }

  function createParticles() {
    particles = [];
    const count = Math.min(30, Math.floor((width * height) / 40000));
    for (let i = 0; i < count; i++) {
      particles.push({
        x: Math.random() * width,
        y: Math.random() * height,
        vx: (Math.random() - 0.5) * 0.3,
        vy: (Math.random() - 0.5) * 0.3,
        size: Math.random() * 2 + 1,
        opacity: Math.random() * 0.4 + 0.1,
        hue: Math.random() * 60 + 230,
      });
    }
  }

  function draw() {
    time += 0.008;
    ctx.clearRect(0, 0, width, height);

    const gradient = ctx.createRadialGradient(
      width * 0.3, height * 0.4, 0,
      width * 0.3, height * 0.4, Math.max(width, height) * 0.6
    );
    gradient.addColorStop(0, "rgba(99, 102, 241, 0.07)");
    gradient.addColorStop(0.5, "rgba(168, 85, 247, 0.03)");
    gradient.addColorStop(1, "rgba(5, 5, 16, 0)");
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);

    const gradient2 = ctx.createRadialGradient(
      width * 0.7, height * 0.6, 0,
      width * 0.7, height * 0.6, Math.max(width, height) * 0.5
    );
    gradient2.addColorStop(0, "rgba(168, 85, 247, 0.05)");
    gradient2.addColorStop(1, "rgba(5, 5, 16, 0)");
    ctx.fillStyle = gradient2;
    ctx.fillRect(0, 0, width, height);

    particles.forEach((p, i) => {
      p.x += p.vx + Math.sin(time + i) * 0.08;
      p.y += p.vy + Math.cos(time * 0.7 + i) * 0.08;

      if (p.x < -20) p.x = width + 20;
      if (p.x > width + 20) p.x = -20;
      if (p.y < -20) p.y = height + 20;
      if (p.y > height + 20) p.y = -20;

      const pulse = Math.sin(time * 2 + i) * 0.2;
      const alpha = p.opacity + pulse * 0.1;

      const glow = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.size * 4);
      glow.addColorStop(0, `hsla(${p.hue}, 80%, 70%, ${alpha})`);
      glow.addColorStop(1, `hsla(${p.hue}, 80%, 70%, 0)`);
      ctx.fillStyle = glow;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size * 4, 0, Math.PI * 2);
      ctx.fill();

      ctx.fillStyle = `hsla(${p.hue}, 80%, 75%, ${alpha * 1.5})`;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.size, 0, Math.PI * 2);
      ctx.fill();
    });

    for (let i = 0; i < particles.length; i++) {
      for (let j = i + 1; j < particles.length; j++) {
        const dx = particles[i].x - particles[j].x;
        const dy = particles[i].y - particles[j].y;
        const dist = Math.sqrt(dx * dx + dy * dy);

        if (dist < 150) {
          const alpha = (1 - dist / 150) * 0.15;
          ctx.strokeStyle = `rgba(99, 102, 241, ${alpha})`;
          ctx.lineWidth = 0.5;
          ctx.beginPath();
          ctx.moveTo(particles[i].x, particles[i].y);
          ctx.lineTo(particles[j].x, particles[j].y);
          ctx.stroke();
        }
      }
    }

    animId = requestAnimationFrame(draw);
  }

  resize();
  createParticles();
  draw();

  window.addEventListener("resize", () => {
    resize();
    createParticles();
  });

  return () => cancelAnimationFrame(animId);
}
